export enum EmailTemplateType {
  INSPECTION_REQUEST = 'INSPECTION_REQUEST',
  ACCOUNT_CREATION = 'ACCOUNT_CREATION',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  OTHER = 'OTHER',
}

export interface ListAllEmailTemplate {
  type?: string;
}

export interface TotalActiveEmailTemplate {
  type?: string;
}
